module.exports = __webpack_public_path__ + "static/media/equipments.b5d00707.svg";